import { CssBaseline } from '@mui/material';
import Router from './shared/routes/Router';
import { AuthProvider } from './modules/auth';
import { ModalProvider } from './shared/context/ModalContext';
import { ThemeModeProvider } from './shared/context/ThemeModeContext';
import { SettingsProvider } from './modules/settings/context/SettingsContext';
import { useEffect } from 'react';
import { useToast } from './shared/hooks/useToast';
import { ErrorBoundaryWithToast } from './shared/components/ErrorBoundary';
import { TenantProvider } from './modules/tenant/context';

function App() {
  const { showToast } = useToast();

  useEffect(() => {
    const handler = (error: any) => {
      console.error(error);
      showToast('Não foi possível realizar a operação, tente novamente mais tarde ou entre em contato com o suporte.', 'error');
    };
    window.addEventListener('globalError', handler);
    return () => window.removeEventListener('globalError', handler);
  }, [showToast]);

  return (
    <ErrorBoundaryWithToast>
      <ThemeModeProvider>
        <CssBaseline />
        <AuthProvider>
          <ModalProvider>
            <SettingsProvider>
              <Router />
            </SettingsProvider>
          </ModalProvider>
        </AuthProvider>
      </ThemeModeProvider>
    </ErrorBoundaryWithToast>
  );
}

export default App;